const $ = window.Bliss
const $$ = $.$

export class Masonry {
  constructor(container, cellSelector) {
    this.container = container
    this.cellSelector = cellSelector

    this.addEventListeners()
  }

  resizeGridItems = () => {
    const rowStyle = getComputedStyle(this.container)
    const rowGap = Number.parseInt(rowStyle.gridRowGap, 10)
    const rowHeight = Number.parseInt(rowStyle.gridAutoRows, 10) + rowGap

    $$(this.cellSelector, this.container).forEach((el) => {
      const childElements = $$(el.children)
      const elHeight = childElements.reduce((height, child) => {
        return child.getBoundingClientRect().height + height
      }, 0)

      const rowSpan = Math.ceil((elHeight + rowGap) / rowHeight)

      el.style.gridRowEnd = `span ${rowSpan}`
    })
  }

  addEventListeners = () => {
    document.addEventListener("DOMContentLoaded", this.resizeGridItems)
    window.addEventListener("load", this.resizeGridItems)
    window.addEventListener("resize", () => {
      this.resizeGridItems()
    })
  }
}
